/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { FieldPath, UseFormReturn } from "react-hook-form";
import { z } from "zod";

import { FormControl, FormField, FormItem } from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TableCell } from "@/components/ui/table";

import { cn } from "@/lib/utils";

export const TableCellNumberSelect = <T extends z.ZodTypeAny>({
  className,
  fieldName,
  form,
  handleOnBlur,
  index,
  listName,
  options,
  placeholder,
  rowId,
}: {
  className?: string;
  fieldName: string;
  form: UseFormReturn<z.infer<T>>;
  handleOnBlur: (
    id: number,
    fieldName: string,
    updatedValue: string | null,
    type?: "date" | "number",
  ) => void;
  index: number;
  listName: "placements" | "requisitions" | "mockResumes";
  options: {
    value: number;
    label: string;
  }[];
  placeholder?: string;
  rowId: number;
}) => {
  const fieldNamePath = `${listName}.${index}.${fieldName}` as FieldPath<
    z.infer<T>
  >;

  return (
    <TableCell className="p-1">
      <FormField
        control={form.control}
        name={fieldNamePath}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Select
                onValueChange={(v) => {
                  field.onChange(Number(v));
                  handleOnBlur(rowId, fieldName, v, "number");
                }}
                // TODO: Required for Owner to properly default, make this cleaner
                value={field.value ? (field.value as number).toString() : ""}
              >
                <SelectTrigger
                  id={`cell-${fieldName}-${index}`}
                  className={cn(
                    "rounded-sm border-transparent bg-transparent hover:border-slate-300 focus:border-slate-300",
                    className,
                  )}
                >
                  <SelectValue placeholder={placeholder} />
                </SelectTrigger>
                <SelectContent>
                  {options.map((option) => (
                    <SelectItem
                      key={option.value}
                      value={option.value.toString()}
                    >
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FormControl>
          </FormItem>
        )}
      />
    </TableCell>
  );
};
